let ajaxURL = pf_data.ajax_url;
let pdfURL = pf_data.pdf_url;
let state = pf_data.state;
let view = pf_data.view;
let stateList = pf_data.states;

export { ajaxURL , pdfURL , state, view , stateList };